import { type PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import { SuspenseBoundary } from '@repo/shared-kit/components';
import { KycError } from './error';
import { useKycContext } from './context';
import { KycPageLoading } from './loading';

export function KycSuspenseBoundary({ children = <Outlet /> }: PropsWithChildren) {
  const { onError } = useKycContext();
  return (
    <SuspenseBoundary
      errorFallback={({ onRetry }) => <KycError onRetry={onRetry} />}
      loadingFallback={<KycPageLoading />}
      onError={onError}
    >
      {children}
    </SuspenseBoundary>
  );
}
